import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37aa95fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = {
  class: "text-left",
  style: {"line-height":"1.2"}
}
const _hoisted_3 = { class: "ellipsis" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-primary text-uppercase" }
const _hoisted_6 = {
  key: 1,
  class: "flex items-center full-height q-px-sm"
}
const _hoisted_7 = { class: "ellipsis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_account_type = _resolveComponent("account-type")!
  const _component_accounts_dropdown = _resolveComponent("accounts-dropdown")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.parentId)
      ? (_openBlock(), _createBlock(_component_q_btn_dropdown, _mergeProps({
          key: 0,
          "menu-anchor": "bottom left",
          "menu-self": "top left",
          title: _ctx.label,
          class: "full-height"
        }, _ctx.$attrs, {
          flat: "",
          "no-caps": ""
        }), {
          label: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_icon, {
                name: "fa fa-users",
                class: "on-left"
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1),
                (_ctx.account)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("small", _hoisted_5, [
                        _createVNode(_component_account_type, {
                          value: _ctx.account.type
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.parent && _ctx.account)
              ? (_openBlock(), _createBlock(_component_accounts_dropdown, {
                  key: 0,
                  parent: _ctx.parent,
                  account: _ctx.account,
                  "onUpdate:account": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:account', $event)))
                }, null, 8, ["parent", "account"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16, ["title"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_q_icon, {
            name: "fa fa-users",
            class: "on-left"
          }),
          _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.label), 1)
        ]))
  ]))
}